var R = Object.defineProperty;
var a = Object.getOwnPropertySymbols;
var N = Object.prototype.hasOwnProperty, E = Object.prototype.propertyIsEnumerable;
var y = (e, n, t) => n in e ? R(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, c = (e, n) => {
  for (var t in n || (n = {}))
    N.call(n, t) && y(e, t, n[t]);
  if (a)
    for (var t of a(n))
      E.call(n, t) && y(e, t, n[t]);
  return e;
};
var T = (e, n) => {
  var t = {};
  for (var o in e)
    N.call(e, o) && n.indexOf(o) < 0 && (t[o] = e[o]);
  if (e != null && a)
    for (var o of a(e))
      n.indexOf(o) < 0 && E.call(e, o) && (t[o] = e[o]);
  return t;
};
import { useRef as v, useCallback as k, useEffect as S, cloneElement as D } from "react";
import { u as L } from "./use-reduced-motion-C9DbPZfj.js";
import { jsx as g } from "react/jsx-runtime";
import { i as H } from "./is-element-C00Aie10.js";
import { f as V, u as O, B as _ } from "./factory-ueRxoNOV.js";
import { u as B } from "./use-styles-DToiHEa6.js";
import { u as C } from "./use-merged-ref-n551Tfbr.js";
function ee({ opened: e, shouldReturnFocus: n = !0 }) {
  const t = v(null), o = () => {
    var r;
    t.current && "focus" in t.current && typeof t.current.focus == "function" && ((r = t.current) == null || r.focus({ preventScroll: !0 }));
  };
  return L(() => {
    let r = -1;
    const s = (i) => {
      i.key === "Tab" && window.clearTimeout(r);
    };
    return document.addEventListener("keydown", s), e ? t.current = document.activeElement : n && (r = window.setTimeout(o, 10)), () => {
      window.clearTimeout(r), document.removeEventListener("keydown", s);
    };
  }, [e, n]), o;
}
const j = /input|select|textarea|button|object/, h = "a, input, select, textarea, button, object, [tabindex]";
function q(e) {
  return process.env.NODE_ENV === "test" ? !1 : e.style.display === "none";
}
function K(e) {
  if (e.getAttribute("aria-hidden") || e.getAttribute("hidden") || e.getAttribute("type") === "hidden")
    return !1;
  let t = e;
  for (; t && !(t === document.body || t.nodeType === 11); ) {
    if (q(t))
      return !1;
    t = t.parentNode;
  }
  return !0;
}
function w(e) {
  let n = e.getAttribute("tabindex");
  return n === null && (n = void 0), parseInt(n, 10);
}
function f(e) {
  const n = e.nodeName.toLowerCase(), t = !Number.isNaN(w(e));
  return /* @ts-expect-error function accepts any html element but if it is a button, it should not be disabled to trigger the condition */ (j.test(n) && !e.disabled || e instanceof HTMLAnchorElement && e.href || t) && K(e);
}
function A(e) {
  const n = w(e);
  return (Number.isNaN(n) || n >= 0) && f(e);
}
function P(e) {
  return Array.from(e.querySelectorAll(h)).filter(A);
}
function U(e, n) {
  const t = P(e);
  if (!t.length) {
    n.preventDefault();
    return;
  }
  const o = t[n.shiftKey ? 0 : t.length - 1], r = e.getRootNode();
  let s = o === r.activeElement || e === r.activeElement;
  const i = r.activeElement;
  if (i.tagName === "INPUT" && i.getAttribute("type") === "radio" && (s = t.filter(
    (u) => u.getAttribute("type") === "radio" && u.getAttribute("name") === i.getAttribute("name")
  ).includes(o)), !s)
    return;
  n.preventDefault();
  const l = t[n.shiftKey ? t.length - 1 : 0];
  l && l.focus();
}
function G(e = !0) {
  const n = v(null), t = (r) => {
    let s = r.querySelector("[data-autofocus]");
    if (!s) {
      const i = Array.from(r.querySelectorAll(h));
      s = i.find(A) || i.find(f) || null, !s && f(r) && (s = r);
    }
    s ? s.focus({ preventScroll: !0 }) : process.env.NODE_ENV === "development" && console.warn(
      "[@mantine/hooks/use-focus-trap] Failed to find focusable element within provided node",
      r
    );
  }, o = k(
    (r) => {
      e && r !== null && n.current !== r && (r ? (setTimeout(() => {
        r.getRootNode() ? t(r) : process.env.NODE_ENV === "development" && console.warn("[@mantine/hooks/use-focus-trap] Ref node is not part of the dom", r);
      }), n.current = r) : n.current = null);
    },
    [e]
  );
  return S(() => {
    if (!e)
      return;
    n.current && setTimeout(() => t(n.current));
    const r = (s) => {
      s.key === "Tab" && n.current && U(n.current, s);
    };
    return document.addEventListener("keydown", r), () => document.removeEventListener("keydown", r);
  }, [e]), o;
}
var x = { root: "m_515a97f8" };
const M = {}, d = V((e, n) => {
  const t = O("VisuallyHidden", M, e), b = t, { classNames: o, className: r, style: s, styles: i, unstyled: m, vars: l } = b, p = T(b, ["classNames", "className", "style", "styles", "unstyled", "vars"]), u = B({
    name: "VisuallyHidden",
    classes: x,
    props: t,
    className: r,
    style: s,
    classNames: o,
    styles: i,
    unstyled: m
  });
  return /* @__PURE__ */ g(_, c(c({ component: "span", ref: n }, u("root")), p));
});
d.classes = x;
d.displayName = "@mantine/core/VisuallyHidden";
function F({
  children: e,
  active: n = !0,
  refProp: t = "ref",
  innerRef: o
}) {
  const r = G(n), s = C(r, o);
  return H(e) ? D(e, { [t]: s }) : e;
}
function I(e) {
  return /* @__PURE__ */ g(d, c({ tabIndex: -1, "data-autofocus": !0 }, e));
}
F.displayName = "@mantine/core/FocusTrap";
I.displayName = "@mantine/core/FocusTrapInitialFocus";
F.InitialFocus = I;
export {
  F,
  ee as u
};
